interface Error {
    error_code: string;
    error_response: string;
}

export class ERRORCODES {
    public static RESPONSE_SUCCESS: Error = {
        error_code: "RESPONSE_SUCCESS",
        error_response: "Anfrage war erfolgreich."
    }
    public static RESPONSE_FAILED_LOGIN: Error = {
        error_code: "RESPONSE_FAILED_LOGIN",
        error_response: "Login mit falscher E-Mail Adresse oder falschem Passwort."
    }
    public static RESPONSE_RESOURCE_MISSING: Error = {
        error_code: "RESPONSE_RESOURCE_MISSING",
        error_response: "Anfrage auf ein Objekt das nicht existiert."
    }
    public static RESPONSE_LIMIT_REACHED: Error = {
        error_code: "RESPONSE_LIMIT_REACHED",
        error_response: "Die Ressourcen des angefragten Objekts sind ausgeschöpft."
    }
    public static RESPONSE_DATABASE_ERROR: Error = {
        error_code: "RESPONSE_DATABASE_ERROR",
        error_response: "Datenbankfehler, z.B. Verletzung des unique-constraints."
    }
    public static RESPONSE_MALFORMED_PAYLOAD: Error = {
        error_code: "RESPONSE_MALFORMED_PAYLOAD",
        error_response: "Fehlende oder fehlerhaft formatierte Parameter im Request Body."
    }
    public static RESPONSE_PAYLOAD_SIZE_EXCEEDED: Error = {
        error_code: "RESPONSE_PAYLOAD_SIZE_EXCEEDED",
        error_response: "Ein Parameter verletzt eine Maximalgröße, z.B. Bilder."
    }
    public static RESPONSE_NOT_EMPTY: Error = {
        error_code: "RESPONSE_NOT_EMPTY",
        error_response: "Das Objekt kann nicht gelöscht werden, da sich noch Objekte darin befinden."
    }
    public static RESPONSE_PAYMENT_REQUIRED: Error = {
        error_code: "RESPONSE_PAYMENT_REQUIRED",
        error_response: "Für die angeforderte Ressource ist ein aktives Abonnement nötig."
    }
    public static RESPONSE_RESOURCE_EXPIRED: Error = {
        error_code: "RESPONSE_RESOURCE_EXPIRED",
        error_response: "Der Token ist abgelaufen"
    }
    public static RESPONSE_RESOURCE_READ_ONLY: Error = {
        error_code: "RESPONSE_RESOURCE_READ_ONLY",
        error_response: "Die angeforderte Ressource darf nicht verändert werden"
    }
    public static RESPONSE_WRONG_API_KEY: Error = {
        error_code: "RESPONSE_WRONG_API_KEY",
        error_response: "Falscher API-Key für die angeforderte Ressource"
    }
    public static RESPONSE_MISSING_PASSWORD: Error = {
        error_code: "RESPONSE_MISSING_PASSWORD",
        error_response: "Das Passwort für die angeforderte Ressource fehlt"
    }
    public static RESPONSE_NOT_AUTHORIZED: Error = {
        error_code: "RESPONSE_NOT_AUTHORIZED",
        error_response: "Nicht authorisiert für die Aktion"
    }
    public static RESPONSE_DUPLICATE_KEY: Error = {
        error_code: "RESPONSE_DUPLICATE_KEY",
        error_response: "Es gibt bereits eine Ressource mit dem gleichen Key"
    }
    public static RESPONSE_UNPROCESSABLE_ENTITY: Error = {
        error_code: "RESPONSE_UNPROCESSABLE ENTITY",
        error_response: "Die Aktion kann nicht verarbeitet werden"
    }
    public static RESPONSE_FORBIDDEN: Error = {
        error_code: "RESPONSE_FORBIDDEN",
        error_response: "Die Aktion ist verboten"
    }
    public static RESPONSE_IN_USE: Error = {
        error_code: "RESPONSE_IN_USE",
        error_response: "Die Ressource kann nicht gelöscht werden, da sie verwendet wird oder Abhängigkeiten existieren"
    }

    public static isErrorCode(response: string): boolean {
        return [
            this.RESPONSE_SUCCESS.error_code,
            this.RESPONSE_FAILED_LOGIN.error_code,
            this.RESPONSE_RESOURCE_MISSING.error_code,
            this.RESPONSE_LIMIT_REACHED.error_code,
            this.RESPONSE_DATABASE_ERROR.error_code,
            this.RESPONSE_MALFORMED_PAYLOAD.error_code,
            this.RESPONSE_PAYLOAD_SIZE_EXCEEDED.error_code,
            this.RESPONSE_NOT_EMPTY.error_code,
            this.RESPONSE_PAYMENT_REQUIRED.error_code,
            this.RESPONSE_RESOURCE_EXPIRED.error_code,
            this.RESPONSE_RESOURCE_READ_ONLY.error_code,
            this.RESPONSE_WRONG_API_KEY.error_code,
            this.RESPONSE_MISSING_PASSWORD.error_code,
            this.RESPONSE_NOT_AUTHORIZED.error_code,
            this.RESPONSE_DUPLICATE_KEY.error_code,
            this.RESPONSE_UNPROCESSABLE_ENTITY.error_code,
            this.RESPONSE_FORBIDDEN.error_code,
            this.RESPONSE_IN_USE.error_code
        ].includes(response)
    }
}
